import { Id, group } from "@planzone/dto";
import { Selector, State } from "./types";

function get(getState: () => State, groupId: Id) {
  return getState().find((res) => res.id === groupId);
}

function queryState(getState: () => State, projectId: Id) {
  return <Result>(
    query: (res: State[number]) => Result,
    fallBack: Result,
  ): Result => {
    const state = get(getState, projectId);

    return state ? query(state) : fallBack;
  };
}

function createSelector(getState: () => State): Selector {
  return {
    isResourceGroupRetrievalRequestFailure(id) {
      return queryState(getState, id)(
        (res) => res.requestState.isFailure,
        false,
      );
    },
    isResourceGroupRetrievalRequestPending(id) {
      return queryState(getState, id)(
        (res) => res.requestState.isPending,
        false,
      );
    },
    isResourceGroupRetrievalRequestSuccess(id) {
      return queryState(getState, id)(
        (res) => res.requestState.isSuccessful,
        false,
      );
    },
    getResourceGroup(id) {
      return queryState(getState, id)((res) => res.group, {
        ...group,
        uuid: id,
      });
    },
  };
}

export { createSelector };
